<header class="custom-header">
    <div class="logo-container">
        <img src="assets/images/logo-colorido-cinza.png" alt="ToLife" class="logo" />
    </div>
    <div class="unit-name">
        <span>{{healthUnitName}}</span>
    </div>
</header>

<div class="container">
    <div class="form-wrapper">
        <h2>Atualizar Endereço</h2>

        <form [formGroup]="model" (ngSubmit)="submit()" #form>
            <mat-form-field appearance="outline">
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="street" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Número</mat-label>
                <input matInput type="number" formControlName="addressNumber" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="addressComplement" />
                <mat-error *ngIf="model.get('addressComplement')?.invalid">
                    Informe o complemento
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="neighborhood" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="outline-spinner">
                <mat-label>CEP</mat-label>
                <input matInput type="text" formControlName="zipCode" (keyup)="onKeySearchCEP($event)"
                    [value]="formatCEP(model.get('zipCode')?.value)" maxlength="9">
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoadingCep == true"></mat-spinner>
                <mat-error *ngIf="model.get('zipCode')?.hasError('invalidCep')">CEP inválido</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="city" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Telefone</mat-label>
                <input matInput formControlName="phone" />
            </mat-form-field>

            <button mat-flat-button color="primary" type="submit">
                Salvar
            </button>
        </form>

        <div class="footer-icon">
            <img src="assets/images/logo-colorido-cinza.png" alt="logo" />
        </div>
    </div>
</div>